import { ReactElement, useMemo } from "react";

import { Select as ChakraSelect } from "chakra-react-select";

import SelectWorkspaceItem from "@/components/SelectWorkspace/SelectWorkspaceItem";
import { useWorkspace } from "@/providers/useWorkspace";
import chakraSelectReactStyles from "@/theme/chakra-react-select/workspaceSelectStyles";

export type Option = {
  value: string;
  label: ReactElement;
};

function SelectWorkspace({
  collapsed,
  onChange = () => {
    return;
  },
  placeholder = "Select...",
  ...props
}: {
  collapsed?: boolean;
  onChange?: (next: Option) => void;
  placeholder?: string;
  selectedValue?: string;
}) {
  const { workspaces, workspaceId } = useWorkspace();
  const options = workspaces?.map(workspace => ({
    value: workspace.databaseId,
    label: <SelectWorkspaceItem workspace={workspace} />,
  }));
  const selectedValue = useMemo(
    () => options?.find(option => option.value === (props.selectedValue ?? workspaceId)),
    [options, props.selectedValue, workspaceId]
  );

  return (
    <ChakraSelect
      aria-label="Select workspace"
      chakraStyles={chakraSelectReactStyles}
      components={{ ...(collapsed && { DropdownIndicator: () => null }) }}
      defaultValue={selectedValue}
      isSearchable={false}
      options={options ?? []}
      placeholder={placeholder}
      value={selectedValue}
      onChange={onChange}
    />
  );
}

export default SelectWorkspace;
